import getErrorKey from '../../components/address/getErrorKey';


const errorPrefix = 'errors.formFields.minEntropy';

const minEntropy = (min, fieldName) => (value) => {
  if (!value) return; // This validator doesn't enforce 'required' constraint, only min length IF value has been provided.
  
  const errorKey = getErrorKey(fieldName, errorPrefix);
  
  let entropy = 0;
  
  const counts = {};
  const len = value.length;
  
  value.split('').forEach((ch) => {
    counts[ch] = counts[ch] ? counts[ch] + 1 : 1;
  });
  
  Object.values(counts).forEach((count) => {
    const probability = count / len;
    entropy -= probability * (Math.log(probability) / Math.log(2));
  });
  
  return entropy < min ? [errorKey, min] : undefined;
};

export default minEntropy;
